import { EditorState, SelectionState, convertFromRaw } from 'tm2-draft-js';

import _ from 'lodash';

class TemplateStore {
  shouldScroll = false;
  load(template, decorators) {
    template = template || '';

    let raw =
      typeof template !== 'object'
        ? JSON.parse(template.trim() !== '' ? template : '{}')
        : template;

    if (_.isEmpty(raw)) {
      return EditorState.createEmpty(decorators);
    }
    let editor = EditorState.createWithContent(convertFromRaw(raw), decorators);
    if (this.shouldScroll) {
      let afterSelectionMove = this.moveSelectionToStart(editor);
      return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
    }
    return editor;
  }

  moveSelectionToStart(editorState) {
    let content = editorState.getCurrentContent();
    let lastBlock = content.getFirstBlock();
    let lastKey = lastBlock.getKey();
    let length = lastBlock.getLength();

    return EditorState.acceptSelection(
      editorState,
      new SelectionState({
        anchorKey: lastKey,
        anchorOffset: length,
        focusKey: lastKey,
        focusOffset: length,
        isBackward: false
      })
    );
  }

  map(template, data) {
    data = data || {};
    template = template || '';

    let raw =
      typeof template !== 'object'
        ? JSON.parse(template.trim() !== '' ? template : '{}')
        : template;

    Object.values(raw.entityMap || {}).map((x) => {
      let { field } = x.data || {};
      if (typeof data[field] !== 'undefined') {
        return;
      }
      data[field] = null;
    });

    return data;
  }
}

export default new TemplateStore();
